import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';
export const CHANGE_SEARCH_FILTER_CAP = defineCapability({
  name: 'CHANGE_SEARCH_FILTER_CAP',
  args: {
    filters: args.arrayOf(args.string())
  }
});